import { render } from "./AuthLayout.vue?vue&type=template&id=0831cc1e&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=0831cc1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0831cc1e"],['__file',"src/layouts/AuthLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0831cc1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0831cc1e', __exports__)) {
    api.reload('0831cc1e', __exports__)
  }
  
  module.hot.accept("./AuthLayout.vue?vue&type=template&id=0831cc1e&scoped=true", () => {
    api.rerender('0831cc1e', render)
  })

}


export default __exports__